export default __webpack_public_path__ + "images/onboarding/side-icon-ed65a10b5ac47449d5d87f7f670c4527.svg";